// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"385":"9a3c7a76","724":"95ce7337","841":"79699716","890":"79699716","900":"e1f97ff9"}[chunkId] + ".chunk.css";
};